import { AvailableComparables } from '../models/available-comparables';
import { ImportCriteria } from '../models/import-criteria';

export class ComparableData {
  availableComparables: AvailableComparables;
  importCriteria: ImportCriteria;
}
